// InstallPrompt - Disabled as per user request
export function InstallPrompt() {
  return null;
}
